import { Attachment } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const AttachmentIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Attachment width={size} height={size} color={color} {...rest} />;

AttachmentIcon.displayName = 'AttachmentIcon';

export default AttachmentIcon;
